import { GlobalContext } from 'Context/GlobalContext/AppContext';
import { useContext, useState, useEffect } from 'react';
import { Document, Page, pdfjs } from 'react-pdf';
import BaseModal from 'components/molecules/BaseModal';
import './styles.scss';
import Pagination from '../Pagination';

pdfjs.GlobalWorkerOptions.workerSrc = '/pdf.worker.min.mjs';

const PdfModal = () => {
  const { pdfModal, setPdfModal, user } = useContext(GlobalContext);

  const [numPages, setNumPages] = useState(null);
  const [pageNumber, setPageNumber] = useState(1);

  // ✅ Melhoria 1: resetar página quando trocar PDF
  useEffect(() => {
    if (pdfModal.url) {
      setPageNumber(1);
      setNumPages(null);
    }
  }, [pdfModal.url]);

  function onDocumentLoadSuccess({ numPages }) {
    setNumPages(numPages);
  }

  return (
    <BaseModal
      isVisible={pdfModal.isVisible}
      handleClose={() => setPdfModal({ isVisible: false })}
    >
      <Document
        file={{
          url: pdfModal.url,
          httpHeaders: {
            Authorization: `Bearer ${user?.token}`,
          },
        }}
        onLoadSuccess={onDocumentLoadSuccess}
        onContextMenu={(e) => e.preventDefault()}
        onLoadError={(err) => console.error("PDF error:", err)}
        className="pdfObject"
        loading={<div className="pdf__loading">Carregando PDF...</div>}
      >
        <Page
          pageNumber={pageNumber}
          className="pdfObject__page"
        />
      </Document>

      {numPages && (
        <Pagination
          page={pageNumber}
          setPage={setPageNumber}
          totalPages={numPages}
        />
      )}
    </BaseModal>
  );
};

export default PdfModal;
